(function () {
    'use strict';

    angular
        .module('salesflare')
        .service('help', helpService);

    function helpService(sfHttp, config) {

        this.get = function () {

            return sfHttp.get(config.apiUrl + 'help', { ignoreLoadingBar: true });
        };
    }
})();
